<template>
  <v-flex sm12 md6>
    <v-card :height="'100%'" tile>
      <v-card-text v-if="!cards.length" class="text-xs-center">
        <v-img class="vr-image" src="img/vr_image.png" max-width="240"></v-img>
        <p class="price">$999</p>
        <!-- <div class="empty-card-text">{{$t('Do you need new glasses? Please, click on the button!')}}</div> -->
        <v-btn color="purple" dark @click="buyGlasses" class="buy-views-btn">{{$t('BUY PURE PURR')}}</v-btn>
        <br>
        <v-btn
          v-if="getCurrentLang == 'en'"
          class="buy-views-btn"
          color="purple"
          dark
          @click="redirectToViewsPage"
        >buy views</v-btn>
      </v-card-text>
      <v-card-text v-if="cards.length">
        <v-data-table :items="cards" hide-actions hide-headers disable-initial-sort>
          <template slot="items" slot-scope="props">
            <td class="card-name">
              <i :class="['pf', 'pf-' + props.item.cardType]"></i>
            </td>
            <td class="font-weight-medium card-number">{{props.item.cardNumber}}</td>
            <td>
              <v-btn
                class="font-weight-bold"
                flat
                color="purple"
                @click="deleteItem(props.item)"
              >{{$t('delete')}}</v-btn>
            </td>
          </template>
          <template slot="no-data">
            <div class="text-xs-center">{{$t('You have no cards')}}</div>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <!-- <v-dialog v-model="buyVrDialog" max-width="500">
      <v-card class="buy-glasses-card">
        <v-card-title class="justify-center">Buy Glasses</v-card-title>
        <v-form class="text-xs-center">
          <v-text-field v-model="email" type="email" placeholder="Email"></v-text-field>
          <v-text-field v-model="subject" placeholder="Subject"></v-text-field>
          <v-textarea v-model="message" rows="4" placeholder="Message" auto-grow></v-textarea>
          <v-btn dark color="purple" type="submit" @click.prevent="sendEmail">submit</v-btn>
        </v-form>
      </v-card>
    </v-dialog>-->
    <promoStepper v-model="showPromoStep" :device_id="device_id" :email="email"></promoStepper>
    <showModal v-model="showDialog" :message="dialogMessage"></showModal>
  </v-flex>
</template>

<script>
//import creditCardType from 'credit-card-type'
import showModal from "@/components/ShowModal";
import axios from "axios";
import promoStepper from "@/components/promoStepper";

export default {
  components: {
    showModal,
    promoStepper
  },

  data: () => ({
    showDialog: false,
    showPromoStep: false,
    device_id: '',
    email: '',
    dialogMessage: "",
    dialogButtonText: "",
    cards: [],
    buyVrDialog: false
  }),

  computed: {
    getCurrentLang() {
      return localStorage.getItem("currentLang");
    }
  },

  methods: {
    deleteItem(item) {
      this.cards.splice(this.cards.indexOf(item), 1);
    },

    buyGlasses() {
      axios
        .get(this.$hostname + "/client/me/", {
          headers: {
            Authorization: localStorage.getItem("token")
          }
        })
        .then(response => {
          console.log(response)
          this.email = response.data.data.email
          this.showPromoStep = true
          this.device_id = 'none'
        })
        .catch(error => {
          this.showDialog = true;
          this.dialogMessage = this.$t(error.response.data.message);
        });
    },

    redirectToViewsPage() {
      this.$router.push("/view/no_device_id");
    }
  }
};
</script>

<style scoped lang="scss">
.v-card {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  padding: 55px;

  .v-icon {
    font-size: 20px;
  }

  // .v-card__text {
  //   position: relative;
  //   top: 50%;
  //   transform: translateY(-50%);
  //   padding: 0;
  // }

  &.buy-glasses-card {
    padding: 20px 50px;
    .v-card__title {
      padding: 5px 0;
      font-size: 18px;
      font-weight: 500;
    }
  }

  @media (max-width: 960px) {
    border-top-right-radius: 0;
    border-bottom-left-radius: 5px;
  }
}

.card-number {
  font-size: 17px;
}

.card-name {
  font-size: 20px;
}

.empty-card-text {
  font-size: 15px;
  margin-bottom: 10px;
  font-weight: 500;
}

.vr-image {
  margin: 0 auto;
}

.price {
  font-weight: 700;
  font-size: 34px;
  color: #800057;
  margin-bottom: 5px;
}

.buy-views-btn{
  min-width: 140px;
}
</style>